module.exports = __webpack_public_path__ + "img/authForteKo.094033ec.png";